export default __webpack_public_path__ + "static/media/colors-480w.bd5ad748.png";